import API from './axios.js';

export const saveDistrictCourtCaseForm = (payload) => API.post('case/district-court/manual', payload);
// export const updateExpense = (expenseData,id) => API.patch(`expense/${id}`, expenseData);
// export const deleteExpense = (id) => API.delete(`expense/${id}`);